// @ts-nocheck
import React from 'react';
import Input from 'antd/lib/input';
import styled from 'styled-components';
import Button from 'antd/lib/button';
import { Filter, Selects } from '../../../components';
import Spoiler from '../../../components/ui/Spoiler';
import Grid, { GridItem } from '../../../components/layout/Grid';
import Field from '../../../components/card/Field';
const Footer = styled(GridItem).attrs({
  fullWidth: true
}).withConfig({
  displayName: "Filter__Footer",
  componentId: "sc-d2muk7-0"
})(["& > *{margin-right:16px;&:last-child{margin-right:0;}}"]);
const SpoilerContent = styled.div.withConfig({
  displayName: "Filter__SpoilerContent",
  componentId: "sc-d2muk7-1"
})(["padding:16px;"]);
const {
  YesNoSelect
} = Selects;
const MdmFilter = ({
  filter,
  cleanFilter,
  applyFilter
}) => {
  return <Spoiler label="Фильтр" defaultExpanded>
      <SpoilerContent>
        <Filter applyFilter={applyFilter} cleanFilter={cleanFilter} initialValues={filter}>
          {({
          values,
          changeValue,
          applyFilter,
          cleanFilter
        }) => <Grid gutter="16px">
              <GridItem>
                <Field label="Мнемокод">
                  <Input value={values.mnemocode} onChange={e => changeValue('mnemocode', e.target.value)} />
                </Field>
              </GridItem>
              <GridItem>
                <Field label="Архив">
                  <YesNoSelect placeholder="" reset fullWidth value={values.isArchive} onChange={value => changeValue('isArchive', value)} />
                </Field>
              </GridItem>
              <Footer>
                <Button type="primary" onClick={applyFilter}>
                  Применить
                </Button>
                <Button onClick={cleanFilter}>Очистить</Button>
              </Footer>
            </Grid>}
        </Filter>
      </SpoilerContent>
    </Spoiler>;
};
export default MdmFilter;
